import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import FileUpload from 'components/DragAndDrop/FileUpload'
import ReactAudioPlayer from 'react-audio-player'
import { useDispatch } from 'react-redux'
import { notifyToast } from 'utils/responseUtils'
import { downloadFile } from 'services/file.service'
import { Button } from '@components/ui/button'
import { Link, Upload } from 'lucide-react'

const MediaType = ({
  itemKey,
  type,
  value,
  isMobile,
  uploadFile,
  selectImage,
  removeMedia,
  addDraggedImageToModel,
  selectedArgsExample,
  setSelectedModel,
  selectedModel,
  updateArgValues,
  fileInputRef,
  initialUrl = '',
}) => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()
  const [pastedUrl, setPastedUrl] = useState(initialUrl)

  const handlePastedFileUpload = async (pastedUrl, isSingleFile) => {
    if (pastedUrl) {
      const file = await downloadFile(pastedUrl)
      uploadFile([file], itemKey, isSingleFile)
    } else {
      dispatch(notifyToast('error', 'Please provide a valide URL'))
    }
  }

  const updateMaskValue = (itemKey, value = '') => {
    let tempSetSelectedModel = structuredClone(selectedModel)
    let maskRemovalSketch = ''
    Object.keys(tempSetSelectedModel.args)
      .filter(
        (item) =>
          tempSetSelectedModel.args[item].type === 'mask' || tempSetSelectedModel.args[item]?.tags?.includes('mask')
      )
      .map((el) => {
        maskRemovalSketch = el
      })
    if (maskRemovalSketch) {
      tempSetSelectedModel.args[maskRemovalSketch].value = value
      tempSetSelectedModel.args[itemKey].value = value
      setSelectedModel(tempSetSelectedModel)
    } else {
      updateArgValues(itemKey, value)
    }
  }

  const renderMedia = {
    video: (
      <video src={value} controls className="w-full max-w-xs rounded-lg overflow-hidden">
        <track kind="captions" />
      </video>
    ),
    audio: <ReactAudioPlayer src={value} controls className="w-full max-w-xs rounded-lg" />,
    image: <img src={value} className="w-full h-full rounded-lg object-cover shadow-sm" alt="media" />,
  }

  useEffect(() => {
    setPastedUrl(initialUrl)
  }, [initialUrl])

  return (
    <div className="upload-img-wrapper">
      {value && (
        <div className="mb-4">
          <div className="relative ">
            <div
              className="absolute -top-2 -right-2 cursor-pointer w-6 h-6 bg-red-500 hover:bg-red-600 rounded-full shadow-lg flex items-center justify-center z-10 transition-colors duration-200"
              onClick={() => {
                removeMedia(itemKey)
                updateMaskValue(itemKey)
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
            {renderMedia[type]}
          </div>
        </div>
      )}
      <FileUpload
        value={value}
        isMobile={isMobile}
        itemKey={itemKey}
        fileInputRef={fileInputRef}
        uploadFile={uploadFile}
        filesToAccept={`${type}/*`}
        isSingleFile={true}
        onDropExtraAction={addDraggedImageToModel}
        type={type}
      />
      <div className="flex items-center relative bg-white border border-gray-200 rounded-lg overflow-hidden mb-3 h-10">
        <div className="flex items-center px-2 text-gray-400">
          <Link className="w-4 h-4" />
        </div>
        <input
          placeholder="Paste URL"
          type="text"
          onChange={(e) => setPastedUrl(e.target.value)}
          onPaste={(e) => setPastedUrl(e.target.value)}
          value={pastedUrl}
          className="w-full py-2 px-1 placeholder:text-sm focus:outline-none h-full text-sm"
        />
        <Button
          size="sm"
          className="px-3 py-1 text-xs rounded-l-none h-full"
          onClick={() => handlePastedFileUpload(pastedUrl, true)}
        >
          Upload
        </Button>
      </div>

      <Button className="w-full py-2 h-10" variant="outline" onClick={() => selectImage(itemKey)}>
        <Upload className="w-4 h-4 mr-2" /> {t('common.library')}
      </Button>

      {selectedArgsExample?.length > 0 && (
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="h-px bg-gray-200 flex-grow"></div>
            <span className="text-xs text-gray-500 font-medium">{t('model.try-example')}</span>
            <div className="h-px bg-gray-200 flex-grow"></div>
          </div>
          <div className="grid grid-cols-4 gap-2 mb-4">
            {selectedArgsExample?.map((items, i) => (
              <div
                key={`sm-imgs-${i}`}
                className="overflow-hidden rounded-lg cursor-pointer hover:opacity-90 transition-opacity duration-200"
                onClick={() => updateMaskValue(itemKey, items.arg_value)}
              >
                <img src={items.preview_media} alt="example" className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default MediaType
